import type { SiteTrend } from '../../../../domain/siteTrend';
import { formatToShortMonthYear } from '../../../../services/timeFormat';

const getGraphPeriod = (siteTrend: Partial<SiteTrend>) => {
  const startDate = siteTrend?.trend?.at(0)?.date;
  const endDate = siteTrend?.trend?.at(-1)?.date;

  if (!startDate || !endDate) {
    return [];
  }

  return [formatToShortMonthYear(startDate), formatToShortMonthYear(endDate)];
};

export default getGraphPeriod;
